import EmailIcon from '@mui/icons-material/Email';
import InputIcon from '@mui/icons-material/Input';
import PhoneIcon from '@mui/icons-material/Phone';

import React from 'react';

import { PoolBrainCustomerLocationDTO } from '_lib/api/apiTypes.shim';
import { Chip } from '_lib/components/Chip/Chip';

import { FlexBox } from '_lib/components/FlexBox/FlexBox';
import { ListItemButton, ListItemButtonProps } from '_lib/components/ListItemButton/ListItemButton';
import { Stack } from '_lib/components/Stack/Stack';

import { Typography, TypographyProps } from '_lib/components/Typography/Typography';

import { formatAddressTwoLine, formatPhone, toSxArray } from '_lib/utils/helpers';

type CustomerLocationDetailProps = {
  customerLocation: PoolBrainCustomerLocationDTO;
  readonly?: boolean;
  showIcon?: boolean;
  headerVariant?: TypographyProps['variant'];
  sx?: ListItemButtonProps['sx'];
};

export const CustomerLocationDetail = (props: CustomerLocationDetailProps) => {
  const { customerLocation, readonly, showIcon, headerVariant, sx } = props;

  return (
    <ListItemButton
      sx={[
        {
          display: 'flex',
          flexDirection: 'row',
          flexGrow: 0,
          justifyContent: 'space-between'
        },
        readonly && {
          pointerEvents: 'none',
          '&:hover': {
            backgroundColor: 'inherit'
          }
        },
        ...toSxArray(sx)
      ]}
      onClick={() => !readonly && window.open(customerLocation.locationURL, '_blank', 'popup')}>
      <Stack>
        <Typography variant={headerVariant || 'h3'} text={customerLocation.customer.name || 'UNKNOWN'} />
        <Typography
          text={formatAddressTwoLine(customerLocation, { includeCountry: true })}
          sx={{ whiteSpace: 'pre-line' }}
        />
        <Stack direction='row'>
          {customerLocation.customer.phoneNumber && (
            <Chip
              label={formatPhone(customerLocation.customer.phoneNumber)}
              size='small'
              icon={<PhoneIcon fontSize='small' />}
            />
          )}
          {customerLocation.customer.email && (
            <Chip label={customerLocation.customer.email} size='small' icon={<EmailIcon fontSize='small' />} />
          )}
        </Stack>
      </Stack>
      <FlexBox>{showIcon && <InputIcon />}</FlexBox>
    </ListItemButton>
  );
};
